// extracted by mini-css-extract-plugin
export var contentsBox = "Contents-module--contentsBox--Fy83T";
export var contentsBoxHeading = "Contents-module--contentsBoxHeading--Gmltv";
export var contentsBoxBody = "Contents-module--contentsBoxBody--H9TLS";